export enum ProfileStateOptions {
  APPROVED = "approved",
  PENDING = "pending_approval",
  IN_PROGRESS = "in_progress",
}
